var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"12","height":"12","viewBox":"0 0 24 24","fill":"black","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 21.883l-6.235-7.527-.765.644 7.521 9 7.479-9-.764-.645-6.236 7.529v-21.884h-1v21.883z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }